<!--begin::Title-->

<!--end::Title-->
<div class="card h-100 w-100">
<div class="card-body  ">

<!--begin::Text-->
<!--end::Text-->

<!--begin::Illustration-->
<div class=" card-p w-100 mb-3 d-flex flex-column align-items-center justify-content-center">
  <h1 class="fw-bolder fs-2hx text-gray-900 mb-4">
    Oops!
  </h1>
<div class=" fw-semibold  fs-2 text-gray-500 mb-7  mt-4 justify-content-center">
  Nous ne trouvons pas cette page.
</div>
  <div>
  <img src="./assets/media/auth/404-error.png" class="mw-100 mh-300px theme-light-show" alt="" />
  <img src="./assets/media/auth/404-error-dark.png" class="mw-100 mh-300px theme-dark-show" alt="" />
  </div>
</div>
<!--end::Illustration-->
</div>
</div>

<!--begin::Link-->
<!--<div class="mb-0">-->
<!--  <a (click)="routeToDashboard()" class="btn btn-sm btn-primary">Return Home</a>-->
<!--</div>-->
<!--end::Link-->
